<template>
  <div class="SayfaContainer">
    <div class="SayfaBaslik">
      <h1>Panel</h1>
      <div class="SayfaBtn el-button-group">
        <el-button size="small" type="default" @click="SayfaYukle" :disabled="lo"> Yenile</el-button>
      </div>
    </div>
    <div class="SayfaIcerik" v-loading="lo">
      <el-row :gutter="20" v-if="AltToplam">
        <el-col :span="24">
          <div class="card mg-b-10">
            <div class="card-body pd-y-30">
              <div class="d-sm-flex">
                <div class="media">
                  <div
                      class="wd-40 wd-md-50 ht-40 ht-md-50 bg-success tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded ">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                         height="24px" viewBox="0 0 24 24" version="1.1">
                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24"/>
                        <circle fill="#FFFFFF" opacity="1" cx="20.5" cy="12.5" r="2.5"/>
                        <rect fill="#FFFFFF" opacity="0.5"
                              transform="translate(12.000000, 6.500000) rotate(-15.000000) translate(-12.000000, -6.500000) "
                              x="3" y="3" width="18" height="7" rx="1"/>
                        <path
                            d="M22,9.33681558 C21.5453723,9.12084552 21.0367986,9 20.5,9 C18.5670034,9 17,10.5670034 17,12.5 C17,14.4329966 18.5670034,16 20.5,16 C21.0367986,16 21.5453723,15.8791545 22,15.6631844 L22,18 C22,19.1045695 21.1045695,20 20,20 L4,20 C2.8954305,20 2,19.1045695 2,18 L2,6 C2,4.8954305 2.8954305,4 4,4 L20,4 C21.1045695,4 22,4.8954305 22,6 L22,9.33681558 Z"
                            fill="#FFFFFF"/>
                      </g>
                    </svg>
                  </div>
                  <div class="media-body">
                    <h6 class="tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8">
                      KASA</h6>
                    <h4 class="Tutar tx-20 tx-sm-18 tx-md-24 tx-normal mg-b-0">{{
                        AltToplam.KasaTx
                      }}<small>,{{ AltToplam.KasaDec }}</small></h4>
                  </div>
                </div>

                <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                  <div
                      class="wd-40 wd-md-50 ht-40 ht-md-50 bg-purple tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded ">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                         height="24px" viewBox="0 0 24 24" version="1.1">

                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24"></rect>
                        <path
                            d="M12.3740377,19.9389434 L18.2226499,11.1660251 C18.4524142,10.8213786 18.3592838,10.3557266 18.0146373,10.1259623 C17.8914367,10.0438285 17.7466809,10 17.5986122,10 L13,10 L13,4.47708173 C13,4.06286817 12.6642136,3.72708173 12.25,3.72708173 C11.9992351,3.72708173 11.7650616,3.85240758 11.6259623,4.06105658 L5.7773501,12.8339749 C5.54758575,13.1786214 5.64071616,13.6442734 5.98536267,13.8740377 C6.10856331,13.9561715 6.25331908,14 6.40138782,14 L11,14 L11,19.5229183 C11,19.9371318 11.3357864,20.2729183 11.75,20.2729183 C12.0007649,20.2729183 12.2349384,20.1475924 12.3740377,19.9389434 Z"
                            fill="#ffffff"></path>
                      </g>
                    </svg>
                  </div>
                  <div class="media-body">
                    <h6 class="tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8">
                      VARLIK</h6>
                    <h4 class="Tutar tx-20 tx-sm-18 tx-md-24 tx-normal mg-b-0">{{
                        AltToplam.VarlikTx
                      }}<small>,{{ AltToplam.VarlikDec }}</small></h4>
                  </div>
                </div>
                <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                  <div
                      class="wd-40 wd-md-50 ht-40 ht-md-50 bg-dark tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded ">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                         height="24px" viewBox="0 0 24 24" version="1.1">

                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24"></rect>
                        <path
                            d="M12.3740377,19.9389434 L18.2226499,11.1660251 C18.4524142,10.8213786 18.3592838,10.3557266 18.0146373,10.1259623 C17.8914367,10.0438285 17.7466809,10 17.5986122,10 L13,10 L13,4.47708173 C13,4.06286817 12.6642136,3.72708173 12.25,3.72708173 C11.9992351,3.72708173 11.7650616,3.85240758 11.6259623,4.06105658 L5.7773501,12.8339749 C5.54758575,13.1786214 5.64071616,13.6442734 5.98536267,13.8740377 C6.10856331,13.9561715 6.25331908,14 6.40138782,14 L11,14 L11,19.5229183 C11,19.9371318 11.3357864,20.2729183 11.75,20.2729183 C12.0007649,20.2729183 12.2349384,20.1475924 12.3740377,19.9389434 Z"
                            fill="#ffffff"></path>
                      </g>
                    </svg>
                  </div>
                  <div class="media-body">
                    <h6 class="tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8">
                      DEMİRBAŞ</h6>
                    <h4 class="Tutar tx-20 tx-sm-18 tx-md-24 tx-normal mg-b-0">{{
                        AltToplam.DemirbasTx
                      }}<small>,{{ AltToplam.DemirbasDec }}</small></h4>
                  </div>
                </div>
                <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                  <div
                      class="wd-40 wd-md-50 ht-40 ht-md-50 bg-primary tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded ">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                         height="24px" viewBox="0 0 24 24" version="1.1">

                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24"></rect>
                        <path
                            d="M15.1231569,19.0111815 L7.83785094,14.818972 C8.31992102,14.3336937 8.67836566,13.7254559 8.86199856,13.0454449 L16.0980947,17.246999 C15.6352738,17.7346932 15.2940944,18.3389541 15.1231569,19.0111815 Z M7.75585639,9.10080708 L15.0774983,4.78750147 C15.2169157,5.48579221 15.5381369,6.11848298 15.9897205,6.63413231 L8.86499752,10.9657252 C8.67212677,10.2431476 8.28201274,9.60110795 7.75585639,9.10080708 Z"
                            fill="#ffffff" fill-rule="nonzero"></path>
                        <circle fill="#ffffff" opacity="0.8" cx="19" cy="4" r="3"></circle>
                        <circle fill="#ffffff" opacity="0.8" cx="19" cy="20" r="3"></circle>
                        <circle fill="#ffffff" opacity="0.8" cx="5" cy="12" r="3"></circle>
                      </g>
                    </svg>
                  </div>
                  <div class="media-body">
                    <h6 class="tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8">ÜRÜN STOK</h6>
                    <h4 class="Tutar tx-20 tx-sm-18 tx-md-24 tx-normal mg-b-0">{{
                        AltToplam.StokTx
                      }}<small>,{{ AltToplam.StokDec }}</small></h4>
                  </div>
                </div>
                <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                  <div
                      class="wd-40 wd-md-50 ht-40 ht-md-50 bg-orange tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                         height="24px" viewBox="0 0 24 24" version="1.1">

                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24"/>
                        <path
                            d="M2,13 C2,12.5 2.5,12 3,12 C3.5,12 4,12.5 4,13 C4,13.3333333 4,15 4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,13 C20,12.4477153 20.4477153,12 21,12 C21.5522847,12 22,12.4477153 22,13 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 C2,15 2,13.3333333 2,13 Z"
                            fill="#ffffff" fill-rule="nonzero" opacity="0.8"/>
                        <rect fill="#ffffff" opacity="0.8"
                              transform="translate(12.000000, 8.000000) rotate(-180.000000) translate(-12.000000, -8.000000) "
                              x="11" y="1" width="2" height="14" rx="1"/>
                        <path
                            d="M7.70710678,15.7071068 C7.31658249,16.0976311 6.68341751,16.0976311 6.29289322,15.7071068 C5.90236893,15.3165825 5.90236893,14.6834175 6.29289322,14.2928932 L11.2928932,9.29289322 C11.6689749,8.91681153 12.2736364,8.90091039 12.6689647,9.25670585 L17.6689647,13.7567059 C18.0794748,14.1261649 18.1127532,14.7584547 17.7432941,15.1689647 C17.3738351,15.5794748 16.7415453,15.6127532 16.3310353,15.2432941 L12.0362375,11.3779761 L7.70710678,15.7071068 Z"
                            fill="#ffffff" fill-rule="nonzero"
                            transform="translate(12.000004, 12.499999) rotate(-180.000000) translate(-12.000004, -12.499999) "/>
                      </g>
                    </svg>
                  </div>
                  <div class="media-body">
                    <h6 class="tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8">ALACAK</h6>
                    <h4 class="Tutar tx-20 tx-sm-18 tx-md-24 tx-normal mg-b-0">{{
                        AltToplam.AlacakTx
                      }}<small>,{{ AltToplam.AlacakDec }}</small></h4>
                  </div>
                </div>
                <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-40">
                  <div
                      class="wd-40 wd-md-50 ht-40 ht-md-50 bg-pink tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px"
                         height="24px" viewBox="0 0 24 24" version="1.1">

                      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <rect x="0" y="0" width="24" height="24"/>
                        <path
                            d="M2,13 C2,12.5 2.5,12 3,12 C3.5,12 4,12.5 4,13 C4,13.3333333 4,15 4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,13 C20,12.4477153 20.4477153,12 21,12 C21.5522847,12 22,12.4477153 22,13 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 C2,15 2,13.3333333 2,13 Z"
                            fill="#ffffff" fill-rule="nonzero" opacity="0.8"/>
                        <rect fill="#ffffff" opacity="0.8" x="11" y="2" width="2" height="14" rx="1"/>
                        <path
                            d="M12.0362375,3.37797611 L7.70710678,7.70710678 C7.31658249,8.09763107 6.68341751,8.09763107 6.29289322,7.70710678 C5.90236893,7.31658249 5.90236893,6.68341751 6.29289322,6.29289322 L11.2928932,1.29289322 C11.6689749,0.916811528 12.2736364,0.900910387 12.6689647,1.25670585 L17.6689647,5.75670585 C18.0794748,6.12616487 18.1127532,6.75845471 17.7432941,7.16896473 C17.3738351,7.57947475 16.7415453,7.61275317 16.3310353,7.24329415 L12.0362375,3.37797611 Z"
                            fill="#ffffff" fill-rule="nonzero"/>
                      </g>
                    </svg>
                  </div>
                  <div class="media-body">
                    <h6 class="tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8">BORÇ</h6>
                    <h4 class="Tutar tx-20 tx-sm-18 tx-md-24 tx-normal mg-b-0">{{
                        AltToplam.BorcTx
                      }}<small>,{{ AltToplam.BorcDec }}</small></h4>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-dashboard mg-b-0">
                <thead>
                <tr>
                  <th>Proje</th>
                  <th class="text-right">Varlık</th>
                  <th class="text-right">Demirbaş</th>
                  <th class="text-right">Stok</th>
                  <th class="text-right">Alacak</th>
                  <th class="text-right">Borç</th>
                  <th class="text-right">Kasa</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="Projeler" v-for="p in Projeler">
                  <td class="tx-color-03 tx-normal">{{ p.Adi }}</td>
                  <td class="text-right tx-purple ">{{ p.Hesap.VarlikTx }}</td>
                  <td class="text-right tx-dark ">{{ p.Hesap.DemirbasTx }}</td>
                  <td class="text-right tx-primary">{{ p.Hesap.StokTx }}</td>
                  <td class="text-right tx-orange">{{ p.Hesap.AlacakTx }}</td>
                  <td class="text-right tx-pink">{{ p.Hesap.BorcTx }}</td>
                  <td class="text-right tx-success">{{ p.Hesap.KasaTx }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-col>

      </el-row>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      lo: false,
      Kasalar: null,
      Projeler: null,
      AltToplam: null,
    }
  },
  methods: {
    SayfaYukle() {
      this.lo = true
      this.$store.dispatch("Get", {path: 'panel'})
          .then(response => {
            this.lo = false
            this.Kasalar = response.Kasalar
            this.Projeler = response.Projeler
            this.AltToplam = response.AltToplam
          })
    }
  },
  created() {
    this.SayfaYukle()
    this.$store.dispatch("title", "Panel");
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Panel/Index.vue